(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-heading-filter"] && !Shopify.designMode) return;
  try {
    
  class CollectionHeadingFilter extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.querySelector('button')?.addEventListener('click', () => {
        const drawer = document.getElementById('filters-drawer');
        if (drawer && typeof drawer.showDialog === 'function') drawer.showDialog();
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  }
  if (!customElements.get('cb-collection-heading')) {
    customElements.define('cb-collection-heading', CollectionHeadingFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
